import { useState, useCallback } from "react";
import { ChatWorkbench } from "../chat/ChatWorkbench";

interface BrowserWorkbenchProps {
  projectName: string;
}

export function BrowserWorkbench({ projectName }: BrowserWorkbenchProps) {
  const [url, setUrl] = useState("https://github.com/scoady/opentool");
  const [browsing, setBrowsing] = useState(false);

  const handleNavigate = useCallback(() => {
    setBrowsing(true);
    // In native mode, the WebView handles real page loading
    // In web mode, we show a placeholder since we can't embed pages
  }, []);

  return (
    <div style={{ height: "calc(100vh - 100px)", display: "flex", flexDirection: "column", gap: ".75rem" }}>
      {/* Address bar */}
      <div className="block" style={{ padding: ".5rem 1rem", display: "flex", alignItems: "center", gap: ".5rem", minHeight: "auto" }}>
        <button style={{ background: "none", border: "none", color: "var(--shell-muted)", cursor: "pointer", fontSize: ".8rem" }}>←</button>
        <button style={{ background: "none", border: "none", color: "var(--shell-muted)", cursor: "pointer", fontSize: ".8rem" }}>→</button>
        <input
          className="chat-input"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleNavigate()}
          style={{
            flex: 1,
            background: "rgba(255,255,255,.03)",
            border: "1px solid var(--shell-line)",
            borderRadius: "6px",
            padding: ".35rem .6rem",
            color: "var(--shell-text)",
            fontSize: ".78rem",
            outline: "none",
          }}
        />
        <button
          onClick={handleNavigate}
          style={{
            background: "var(--shell-accent)",
            border: "none",
            borderRadius: "6px",
            padding: ".35rem .75rem",
            color: "var(--shell-bg)",
            fontSize: ".72rem",
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          Go
        </button>
      </div>

      {/* Browser + assist */}
      <div className="slab-grid slab-21" style={{ flex: 1 }}>
        {/* Page surface */}
        <div className="block" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          <div style={{ textAlign: "center", opacity: .4, padding: "3rem" }}>
            <div style={{ fontSize: "2.5rem", marginBottom: "1rem" }}>🌐</div>
            <div style={{ fontSize: "1rem", fontWeight: 600, marginBottom: ".5rem" }}>
              {browsing ? "Page loaded in background" : "Browser Surface"}
            </div>
            <div style={{ fontSize: ".8rem", lineHeight: 1.6, maxWidth: "400px", margin: "0 auto" }}>
              {browsing
                ? "Most sites block iframe embedding. In native mode (macOS/Linux desktop), this surface uses real WebKit for full page rendering."
                : "Enter a URL above and press Go. The browser assist panel can help you navigate and understand web content."}
            </div>
            {browsing && (
              <button
                onClick={(e) => { e.preventDefault(); window.open(url, "_blank", "noopener"); }}
                style={{ display: "inline-block", marginTop: "1rem", color: "var(--shell-accent)", fontSize: ".8rem", background: "none", border: "1px solid var(--shell-accent)", borderRadius: "6px", padding: ".3rem .75rem", cursor: "pointer" }}
              >
                Open in new tab →
              </button>
            )}
          </div>
        </div>

        {/* Browser assist */}
        <div className="block" style={{ display: "flex", flexDirection: "column" }}>
          <h4>Browser Assist</h4>
          <div className="chat-messages" style={{ flex: 1 }}>
            <div className="chat-msg agent">
              I can help you navigate and understand web content. Ask me about the current page or request actions.
            </div>
          </div>
          <div className="chat-input">
            <input placeholder="Ask about this page..." />
            <button>Ask</button>
          </div>
        </div>
      </div>
    </div>
  );
}
